"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getSession = getSession;
exports.refreshSession = refreshSession;
exports.initSession = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _api = require("./api");

var _log = require("./utils/log");

var CGI_CREATE_SESSION = 'https://qblogin.kandian.qq.com/trpc.tkdqb.qblogin.qblogin/CreateSession';
var sessionObserver;
var extUserInfo;
var createSessionPromise;
var expireTime = 86400000;
var aegis = new _api.AegisModule();

function initOpt(opt) {
  new _log.Logger('_initOpt').log(opt);

  if (opt !== null && opt !== void 0 && opt.isDebug) {
    (0, _log.setDebugFlag)(opt.isDebug);
  }

  if (opt !== null && opt !== void 0 && opt.cgiUrl) {
    CGI_CREATE_SESSION = opt === null || opt === void 0 ? void 0 : opt.cgiUrl;
  }

  if (opt !== null && opt !== void 0 && opt.sessionObserver) {
    sessionObserver = opt === null || opt === void 0 ? void 0 : opt.sessionObserver;
  }

  if (opt !== null && opt !== void 0 && opt.extUserInfo) {
    extUserInfo = opt === null || opt === void 0 ? void 0 : opt.extUserInfo;
  }

  if (opt !== null && opt !== void 0 && opt.expireTime) {
    expireTime = opt === null || opt === void 0 ? void 0 : opt.expireTime;
  }

  if (opt !== null && opt !== void 0 && opt.logObserver) {
    (0, _log.setLogObserver)(opt === null || opt === void 0 ? void 0 : opt.logObserver);
  }
}
/**
 * 初始化api，业务方接入npm包之后需要先调用一下
 * 通过jsapi获取用户信息然后请求后台换取session，以及对应token过期的操作
 * @param opt
 */


var initSession = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(opt) {
    var log, accountInfo, _sessionInfo, _res;

    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            initOpt(opt);
            aegis.infoAll({
              location: 'initSession start',
              opt: opt
            });
            log = new _log.Logger('initSession'); // 设置login切换变化

            (0, _api.onLoginUserSwitch)( /*#__PURE__*/function () {
              var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(args) {
                return _regenerator["default"].wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        new _log.Logger('onLoginUserSwitch').log();
                        _context.next = 3;
                        return (0, _api.clearStroage)(args);

                      case 3:
                        createSession(args);

                      case 4:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x2) {
                return _ref2.apply(this, arguments);
              };
            }()); // 换取session

            _context2.prev = 4;
            log.log('---start---'); // initSession会尝试存到缓存将设备信息

            _context2.next = 8;
            return (0, _api.getAccountInfo)();

          case 8:
            accountInfo = _context2.sent;
            _context2.next = 11;
            return (0, _api.getStorage)(accountInfo, expireTime);

          case 11:
            _sessionInfo = _context2.sent;

            if (!(_sessionInfo !== null && _sessionInfo !== void 0 && _sessionInfo.sa && _sessionInfo !== null && _sessionInfo !== void 0 && _sessionInfo.qbid)) {
              _context2.next = 16;
              break;
            }

            _context2.t0 = _sessionInfo;
            _context2.next = 19;
            break;

          case 16:
            _context2.next = 18;
            return createSession(accountInfo);

          case 18:
            _context2.t0 = _context2.sent;

          case 19:
            _res = _context2.t0;
            log.log('---end---', _res);
            aegis.infoAll({
              location: 'initSession end',
              res: _res
            });
            return _context2.abrupt("return", _res);

          case 25:
            _context2.prev = 25;
            _context2.t1 = _context2["catch"](4);
            log.error(_context2.t1, 'initSession error');
            aegis.error({
              location: 'initSession error',
              error: _context2.t1
            });
            return _context2.abrupt("return", {});

          case 30:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[4, 25]]);
  }));

  return function initSession(_x) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * 获取session的api，支持业务侧传入强登陆逻辑，在无登录态的情况下唤起登陆面板
 * @param forceLogin 没有登陆是否强制拉取登陆面板
 * @param loginParams forceLogin为true时传到loginPanel的参数，hippy和H5具体传什么看JSAPI的showLoginPanel和QBAccountModule.showLoginPanel
 */


exports.initSession = initSession;

function getSession(_x3, _x4) {
  return _getSession.apply(this, arguments);
}
/**
 * 业务侧感知到session过期后，调用此api重新获取session
 * 注意！！！此api在已有登录态的情况下使用，业务侧需要保证这一点
 */


function _getSession() {
  _getSession = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(forceLogin, loginParams) {
    var log, accountInfo, _sessionInfo2, _res2;

    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            log = new _log.Logger('getSession');
            _context3.prev = 1;
            log.log('---start---');
            _context3.next = 5;
            return (0, _api.getAccountInfo)({
              isNeedLogin: !!forceLogin,
              loginParams: loginParams
            });

          case 5:
            accountInfo = _context3.sent;
            _context3.next = 8;
            return (0, _api.getStorage)(accountInfo, expireTime);

          case 8:
            _sessionInfo2 = _context3.sent;

            if (!(_sessionInfo2 !== null && _sessionInfo2 !== void 0 && _sessionInfo2.sa && _sessionInfo2 !== null && _sessionInfo2 !== void 0 && _sessionInfo2.qbid)) {
              _context3.next = 13;
              break;
            }

            _context3.t0 = _sessionInfo2;
            _context3.next = 16;
            break;

          case 13:
            _context3.next = 15;
            return createSession(accountInfo);

          case 15:
            _context3.t0 = _context3.sent;

          case 16:
            _res2 = _context3.t0;
            aegis.infoAll({
              location: 'getSession success',
              res: _res2
            });
            log.log('---end---', _res2);
            return _context3.abrupt("return", _res2);

          case 22:
            _context3.prev = 22;
            _context3.t1 = _context3["catch"](1);
            log.error(_context3.t1, 'getSession error');
            aegis.error({
              location: 'getSession error',
              error: _context3.t1
            });
            return _context3.abrupt("return", {});

          case 27:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 22]]);
  }));
  return _getSession.apply(this, arguments);
}

function refreshSession() {
  return _refreshSession.apply(this, arguments);
}

function _refreshSession() {
  _refreshSession = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
    var log, accountInfo, newAccountInfo, _res3;

    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            log = new _log.Logger('refreshSession');
            _context4.prev = 1;
            log.log('---start---');
            _context4.next = 5;
            return (0, _api.getAccountInfo)();

          case 5:
            accountInfo = _context4.sent;
            _context4.next = 8;
            return (0, _api.refreshToken)({
              uin: accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.uin
            })["catch"]();

          case 8:
            newAccountInfo = _context4.sent;
            _context4.next = 11;
            return createSession(newAccountInfo);

          case 11:
            _res3 = _context4.sent;
            aegis.infoAll({
              location: 'refreshSession success',
              res: _res3
            });
            log.log('---end---', _res3);
            return _context4.abrupt("return", _res3);

          case 17:
            _context4.prev = 17;
            _context4.t0 = _context4["catch"](1);
            log.error(_context4.t0, 'refreshSession error');
            aegis.error({
              location: 'refreshSession error',
              error: _context4.t0
            });
            return _context4.abrupt("return", {});

          case 22:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[1, 17]]);
  }));
  return _refreshSession.apply(this, arguments);
}

function createSession(_x5) {
  return _createSession.apply(this, arguments);
}

function _createSession() {
  _createSession = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(accountInfo) {
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            // createSession的promise没有resolve，多次调用返回相同promise
            if (!createSessionPromise) {
              createSessionPromise = (0, _api.fetchSession)({
                accountInfo: accountInfo,
                sessionObserver: sessionObserver,
                extUserInfo: extUserInfo,
                cgiUrl: CGI_CREATE_SESSION,
                setStorage: _api.setStorage
              })["finally"](function () {
                createSessionPromise = null;
              });
            }

            return _context5.abrupt("return", createSessionPromise);

          case 2:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _createSession.apply(this, arguments);
}